import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import LanguageRoundedIcon from '@material-ui/icons/LanguageRounded';
import { lightBlue } from '@material-ui/core/colors';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import logo_dsp from '../../assets/img/logo_dsp.png';
import logo_dspEn from '../../assets/img/logo_dsp_en.png';
import logo_trusted_top from '../../assets/img/logo_trusted_top.png';

const useStyles = makeStyles(theme => ({
  headerWrapper: {
    // display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    background: '#154770',
    // background: '#0077b5',
    boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.12), inset 0 -1px 0 0 #dadce0',
    left: '0',
    margin: '0',
    padding: '0',
    position: 'fixed',
    top: '0',
    zIndex: '2',
    color: 'white',
  },
  contentWrapper: {
    height: '64px !important',
    width: '1170px',
    padding: '0 15px',
    alignItems: 'center',
    display: 'flex',
    fontSize: '0',
    justifyContent: 'space-between',
    overflow: 'unset',
    position: 'relative',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  headerTittle: {
    fontSize: '16px',
    textAlign: 'initial',
    float: 'left',
    // fontWeight: '700',
  },
  logoTittle: {
    float: 'right',
    width: '72px',
  },
  headerSubTittle: {
    fontSize: '12px',
  },
  root: {
    background: 'blue',
    marginBottom: '10px',
  },
  root2: {
    background: 'grey',
    marginBottom: '10px',
  },
  whiteColor: {
    color: 'white',
  },
  select: {
    '&:before': {
      borderColor: 'white',
    },
    '&:after': {
      borderColor: 'white',
    },
  },
}));

const Header = ({ lang, handleLangSelector }) => {
  const classes = useStyles();

  return (
    <div className={classes.headerWrapper}>
      <div className={classes.contentWrapper}>
        <Grid container>
          <Grid item md={10} xs={8}>
            <a href="https://tadvisorsgroup.com/">
              <img
                src={logo_trusted_top}
                style={{ width: '125px', float: 'left' }}
                alt="Trusted Advisors, Inc."
              />
            </a>
          </Grid>
          <Grid item md={1}>
            <div style={{ marginTop: '9px', display: 'inline-flex' }}>
              <div
                style={{
                  paddingTop: '4px',
                  marginRight: '6px',
                }}
              >
                <LanguageRoundedIcon style={{ color: lightBlue[200] }} />
              </div>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={lang}
                onChange={handleLangSelector}
                classes={{
                  root: classes.whiteColor,
                  icon: classes.whiteColor,
                }}
                className={classes.select}
              >
                <MenuItem value={'es'}>ES</MenuItem>
                <MenuItem value={'en'}>EN</MenuItem>
              </Select>
            </div>
          </Grid>
          <Grid item md={1}>
            <img
              src={lang === 'es' ? logo_dsp : logo_dspEn}
              className={classes.logoTittle}
              alt="DSP"
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Header;
